import React, { useState, useEffect, useMemo } from 'react';
import { Button, Card, CardBody, Input, Label, FormGroup } from 'reactstrap';
import { Helmet } from 'react-helmet';
import { IconButton, Box, TextField } from '@mui/material';
import * as Icon from 'react-feather';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast, Flip } from 'react-toastify';
import { AnimatePresence } from 'framer-motion';
import FilterListIcon from '@mui/icons-material/FilterList';
import SweetAlert from '../../../../components/main/SweetAlert';
import FilterTools from '../../../../components/main/FilteredBody/Users';
import AnimationDiv from '../../../../components/main/Animations/Transition';
import userService from '../../../../services/users';
import stateProvinceService from '../../../../services/state_province';
import { fetchData } from '../../../../redux/modules/users/actions';
import { useQuery } from '../../useQuery';
import Loading from '../../../../components/main/Loading';
import Table from '../../../../components/main/table';
import { userHeader } from '../../../../redux/constants/table/headers';
import { headerMaker } from '../../../../components/main/table/helper';
import { toolTips } from './helper';
import { useStyles } from './style';

export default function Dispatchers() {
  const {
    query,
    search,
    deleted,
    pageIndex,
    pageSize,
    setPageIndex,
    setPageSize,
    setSearch,
    setDeleted,
    setRefresh,
    handleOnTableChange,
  } = useQuery({ fetchData });

  const navigate = useNavigate();
  const classes = useStyles();
  const [isFilterShow, setFilterIsShow] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [states, setStates] = useState([]);
  const [page, setPage] = useState(null);
  const [modal, setModal] = useState(false);
  const headers = useMemo(() => headerMaker(userHeader), [userHeader]);

  const { data, loading, total } = useSelector((state) => state.usersReducer);
  localStorage.setItem('total_data', total);

  const createHeaders = (headerData) => {
    const cData = headerData.map((item) => ({
      item,
      // ref: useRef(),
    }));
    // console.log(cData);

    // setColumns(cData);

    return cData;
  };

  const [columns, setColumns] = useState(createHeaders(headers));

  // state = {
  //   deleteAlert: false,
  //   data: [],
  //   states: [],
  //   paginationPageSize: 100000,
  //   page: null,
  //   total: 1,
  //   defaultColDef: {
  //     sortable: true,
  //     resizable: true,
  //     // suppressMenu: true,
  //     // wrapText: true,
  //     autoHeight: true,
  //     floatingFilter: true,
  //     tooltipValueGetter: (params) => {
  //       return params.value;
  //     },
  //   },
  //   loading: false,
  //   columnDefs: [
  //     {
  //       headerName: 'ID',
  //       field: 'id',
  //       maxWidth: 80,
  //       flex: 1,
  //     },
  //     {
  //       headerName: 'Username',
  //       field: 'username',
  //       minWidth: 100,
  //       filter: 'agTextColumnFilter',
  //       flex: 2,
  //     },
  //     {
  //       headerName: 'Name',
  //       field: 'name',
  //       minWidth: 100,
  //       filter: 'agTextColumnFilter',
  //       flex: 2,
  //     },
  //     {
  //       headerName: 'Phone Number',
  //       field: 'phone',
  //       minWidth: 100,
  //       filter: false,
  //       flex: 1,
  //     },
  //     {
  //       headerName: 'Role',
  //       field: 'role',
  //       minWidth: 100,
  //       filter: false,
  //       flex: 1,
  //     },
  //     {
  //       maxWidth: 130,
  //       flex: 1,
  //       headerName: 'Actions',
  //       field: 'actions',
  //       sortable: false,
  //       editable: false,
  //       suppressMenu: false,
  //       filter: false,
  //       cellRendererFramework: (params) => {
  //         return (
  //           <div>
  //             <Link to={`/users/edit/${params.data.id}`}>
  //               <Icon.Edit
  //                 onClick={() => history.push()}
  //                 className="icon-button ml-1"
  //                 size={20}
  //                 color="darkgray"
  //               />
  //             </Link>
  //             <Icon.Delete
  //               onClick={() => this.nominateToDelete(params.data.id)}
  //               className="icon-button ml-1"
  //               size={20}
  //               color="darkgray"
  //             />
  //           </div>
  //         );
  //       },
  //     },
  //   ],
  // };

  const nominateToDelete = (id) => {
    setDeletingId(id);
    setDeleteAlert(true);
  };

  const updateInfo = () => {
    // setLoading(true);

    userService
      .getAll(`sort=id,DESC&size=100000&page=${page}`)
      .then((data) => {
        const dataToShow = [];
        data.content.forEach((el, i) => {
          const elToShow = {
            name: el.name,
            id: el.id,
            username: el.username,
            role: el.role,
            phone: el.phone,
          };
          dataToShow.push(elToShow);
        });

        // setData(dataToShow);
        // setLoading(false);
        // setTotal(data.totalElements);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          transition: Flip,
        });
      });
  };

  const deleteDispatcher = () => {
    userService
      .delete(deletingId)
      .then((res) => {
        setRefresh(true);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          transition: Flip,
        });
      });
    setDeletingId(null);
    setDeleteAlert(false);
  };

  const componentDidMount = () => {
    // setLoading(true);

    stateProvinceService
      .getAll()
      .then((data) => {
        setStates(data);

        // updateInfo();
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          transition: Flip,
        });
      });
  };

  const doubleClick = (id) => {
    navigate(`/users/edit/${id}`);
  };

  useEffect(() => {
    componentDidMount();
  }, []);

  const handleModal = () => {
    setModal(!modal);
  };

  return (
    <>
      <Helmet>
        <title> Users </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: '#000',
          height: 'calc(100vh - 6.5rem)',
          py: 1,
        }}
      >
        <Loading loading={loading} />
        <SweetAlert
          title="Are you sure?"
          warning
          show={deleteAlert}
          showCancel
          reverseButtons
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          onConfirm={() => {
            deleteDispatcher(deletingId);
          }}
          onCancel={() => setDeleteAlert(false)}
        >
          You won`t be able to revert this!
        </SweetAlert>
        <Card
          className="overflow-hidden agGrid-card"
          style={{ marginRight: 8 }}
        >
          <div className="d-flex justify-content-between mt-2 mx-2 mb-1">
            <h3>All users list</h3>
            <div>
              <Link
                to="/users/new"
                className="d-flex align-items-center text-white"
              >
                <Button
                  color="success"
                  className="d-flex align-items-center"
                  type="button"
                  size="sm"
                >
                  <Icon.Plus size={20} /> Add new user
                </Button>
              </Link>
            </div>
          </div>
          <div className="d-flex align-items-center mb-1 mx-2">
            <TextField
              fullWidth
              size="small"
              id="search"
              label="Search"
              variant="outlined"
              onChange={(e) => setSearch(e.target.value)}
            />
            <IconButton
              color="primary"
              aria-label="filter"
              onClick={() => {
                setFilterIsShow(!isFilterShow);
              }}
            >
              <FilterListIcon />
            </IconButton>
            {/* <h4 className="mx-1 mb-0 text-nowrap">&nbsp;</h4> */}
          </div>
          <div className={isFilterShow ? 'align-items-center mb-3 mx-2' : ''}>
            <AnimatePresence className={classes.filters}>
              {isFilterShow ? (
                <AnimationDiv>
                  <FilterTools deleted={deleted} setDeleted={setDeleted} />
                </AnimationDiv>
              ) : null}
            </AnimatePresence>
          </div>

          <CardBody className="py-0 no-pagination">
            <div className="w-100 ag-grid-table with-pagination">
              <Table
                data={data}
                headers={headers}
                toolTips={toolTips}
                onChange={handleOnTableChange}
                modal={handleModal}
                deleteModal={nominateToDelete}
                doubleClick={doubleClick}
                columns={columns}
                setColumns={setColumns}
                // hidePagination={1}
              />
            </div>
          </CardBody>
        </Card>
      </Box>
    </>
  );
}

// const mapStateToProps = (state) => {
//   return {
//     token: state.auth.login.token,
//   };
// };
// export default connect(mapStateToProps)(Dispatchers);
